import { CoreTooltip } from '@featuring-corp/components';
import { IconInformationFilled } from '@featuring-corp/icons';
import { vars } from '@styles/vanilla-extract/theme.css';
import { flex } from '@styles/vanilla-extract/utils';
import clsx from 'clsx';
import React, { ComponentPropsWithoutRef, ReactNode } from 'react';

import {
	descriptionClass,
	headerClass,
	headingClass,
	placementClass,
	sectionClass,
} from './style.css';

export interface ReportSectionProps
	extends Omit<ComponentPropsWithoutRef<'section'>, 'title'> {
	title?: ReactNode;
	tooltip?: string;
	description?: ReactNode;
	children?: ReactNode | ReactNode[];
}

const ReportSection = ({
	title,
	tooltip,
	description,
	children,
	className,
	...props
}: ReportSectionProps) => {
	return (
		<section className={clsx(sectionClass, className)} {...props}>
			<div className={headerClass}>
				<h2 className={headingClass}>{title}</h2>
				<div className={flex({ gap: 'spacing-150' })}>
					<div className={placementClass}>{title}</div>
					{tooltip && (
						<CoreTooltip text={tooltip} autoAdjust zIndex={10000}>
							<IconInformationFilled fill={vars.semantic.color.icon.tertiary} />
						</CoreTooltip>
					)}
				</div>
				{description && <p className={descriptionClass}>{description}</p>}
			</div>

			{children}
		</section>
	);
};

export default ReportSection;
